export const JSON_SHAPE_NAME = 'JSON';
